<ng-template #router>
    <router-outlet></router-outlet>
  </ng-template>

  <ng-container *ngIf="isLoggedIn$ | async; else router">
    <div>
      <app-direct-homepage-layout>
        <ng-container *ngTemplateOutlet="router"></ng-container>
      </app-direct-homepage-layout>
    </div>
  </ng-container>